// DS: C86
/** An animation put in place while we load the actual content */
import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import OutlinedDASymbol from '../OutlinedDASymbol';
import { usePortalNode } from '@wix/da-ds/pkg/popper/hooks/usePortalNode';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useLoaderDelay } from './useLoaderDelay';
import s from './LoadingIndicator.scss';
var LoadingIndicatorPortal = function (_a) {
    var children = _a.children;
    var portalContainer = usePortalNode('loadingIndicator');
    return portalContainer && ReactDOM.createPortal(children, portalContainer);
};
var LoadingIndicator = function (_a) {
    var _b = _a.view, view = _b === void 0 ? 'spinner' : _b, _c = _a.coverMode, coverMode = _c === void 0 ? false : _c, _d = _a.withOverlay, withOverlay = _d === void 0 ? false : _d, className = _a.className, spinnerClassName = _a.spinnerClassName, _e = _a.usePortal, usePortal = _e === void 0 ? false : _e;
    var pride = useFlag('pride22');
    // Delayed showing for better UX
    var showLoader = useLoaderDelay();
    var content = (React.createElement("div", { className: classnames(s['root'], showLoader && s['visible'], s["view-".concat(view)], coverMode && s['cover-mode'], withOverlay && s['with-overlay'], usePortal && s['fixed-position'], className) }, {
        daSymbol: React.createElement(OutlinedDASymbol, null),
        daSymbolPurple: React.createElement(OutlinedDASymbol, { palette: "purple" }),
        watchSuggestions: React.createElement(OutlinedDASymbol, { palette: "green-to-purple" }),
        llama: React.createElement("div", { className: pride ? s['llama-pride22'] : s['llama'] }),
        spinner: (React.createElement("div", { className: classnames(s['spinner'], spinnerClassName) })),
    }[view]));
    if (usePortal) {
        return React.createElement(LoadingIndicatorPortal, null, content);
    }
    return content;
};
LoadingIndicator.displayName = 'LoadingIndicator';
export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map